module.exports = __webpack_public_path__ + "img/straight-rail-diagonal-right-bottom-ties-remnants.ed26dc2e.png";